module.exports = __webpack_public_path__ + "static/img/global_add@3x.ebb5520.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/global_add@3x.png
// module id = kk7g
// module chunks = 1